import { render } from "./SetupWaring.vue?vue&type=template&id=fceef7fe"
import script from "./SetupWaring.vue?vue&type=script&lang=js"
export * from "./SetupWaring.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__